<template>
  <section class="w-full h-full flex flex-col items-center justify-center">
    <i class="el-icon-success text-9xl text-theme"></i>
    <p class="mt-8 text-theme-black-850 text-medium">恭喜您，群发短信发送成功！</p>
    <el-button type="primary" size="small" class="mt-6" @click="finish">查看短信发送明细</el-button>
  </section>
</template>

<script>
import GlobalConfig from '@/global/config'
import { updateSmsAuditH } from '@/api/wenjuan/sample_new'
export default {
  name: 'StepPayResult',
  inject: {
    switchTab: {
      default: null
    },
    resetGSM: {
      default: null
    },
    source: {
      default: () => ({})
    }
  },
  computed: {
    isSuccess() {
      const { sendResult } = this.source?.smsRecord || {}
      return !!sendResult
    }
  },
  methods: {
    finish() {
      if (typeof this.switchTab === 'function') {
        this.switchTab('batchRecord', br => {
          br.searchList()
        })
      }
      if (typeof this.resetGSM === 'function') {
        this.resetGSM()
      }

      if (this.source.showlistNoRequest) return

      const surveyId = GlobalConfig.getSurveyId()
      updateSmsAuditH({ surveyId }).then(_ => {})
    }
  }
}
</script>
